var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39098e-06 0.499999C8.03824e-06 0.223857 0.223865 0 0.500007 0H11.5C11.7762 0 12 0.223858 12 0.500001L12 3.17892C12 3.35711 11.7846 3.44634 11.6586 3.32034L10.5882 2.25H7.05884V12.75H9.17644V14.4117H2.8235V12.75H4.94119V2.25H1.41176L0.341423 3.32034C0.21543 3.44634 0 3.3571 0 3.17892L7.39098e-06 0.499999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.8a7d1ffa81c390a17ef6f25e675a4a3a.svg";
export { ForwardRef as ReactComponent };